import React, {useEffect, useState} from 'react';
import {withRouter, useParams} from 'react-router-dom';
import {connect} from 'react-redux';

import {IP_APPEAL_QUESTION_OPTIONS, VERIFY_OPTIONS} from '../appeal/conf';
import {handleLogin} from '../../util';
import {Image} from 'antd';

import {fetchIpDetail} from '../../actions/ipAppealAction';
import iconToast from '../../../src/asset/img/infoAttest/icon_toast.png';
import iconSuccess from '../../../src/asset/img/infoAttest/icon_success.png';
import './index.less';
interface IProps {
    fetchIpUserInfo: () => void;
    fetchDataDetail: (params) => Promise<any>;
}

interface IUrlProps {
    id: string;
}
interface IPageDetail {
    status: 0 | 1;
    user_res?: string;
    created?: string;
    class: number;
    desc?: string;
    link?: string;
    ip?: string;
}
export function IpAppealDetail(props: IProps) {
    const {fetchIpUserInfo, fetchDataDetail} = props;
    const {id} = useParams<IUrlProps>();
    const [pageDetail, setPageDetail] = useState<IPageDetail>({} as IPageDetail);

    useEffect(() => {
        window.scrollTo(0, 0);
        handleLogin(fetchIpUserInfo);
    }, [location.pathname]);

    useEffect(() => {
        initData(id);
    }, [id]);

    const initData = async (id) => {
        const res = await fetchDataDetail(id);
        if (res.code === 200) {
            setPageDetail(res.data[0]);
        }
    };

    const handleStatusText = (value) => {
        return VERIFY_OPTIONS.find(item => item.value === value)?.label || '--';
    };
    const handleQuestionType = (value) => {
        return IP_APPEAL_QUESTION_OPTIONS.find(item => item.value === value)?.label || '--';
    };

    return(<div className="ip-appeal-page">
        <div className="top-banner">
            <div className={'carousel-item ip-appeal-banner'}>
                <div className="item-info-wrapper">
                    <span className="title">百度智能云·IP风险画像·信息报错-反馈进度查询</span>
                </div>
            </div>

        </div>
        <div className="ip-appeal-detail">
            <div className="info-status">
                <div className="left">
                    <div className="title">
                        <img src={pageDetail.status === 0 ? iconToast : iconSuccess} alt="" />
                        <div>{handleStatusText(pageDetail.status)}</div>
                    </div>
                    {pageDetail.user_res && <div className="text">
                        {pageDetail.user_res}
                    </div>}
                </div>
                <div className="right">
                    <div>反馈时间：{pageDetail.created}</div>
                </div>
            </div>
            <div className="info-detail">
                <div className="info-item">
                    <div className="big-text">
                        {pageDetail.ip}
                    </div>
                </div>
                <div className="info-item">
                    <div className="label">问题类型：</div>
                    <div className="value">{handleQuestionType(pageDetail.class)}</div>
                </div>
                <div className="info-item">
                    <div className="label">问题说明：</div>
                    <div className="value">{pageDetail.desc}</div>
                </div>
                <div className="info-item">
                    <div className="label">问题截图：</div>
                    <div className="value">
                        {pageDetail.link ? <Image width={200} src={pageDetail.link} /> : '--'}
                    </div>
                </div>
            </div>
        </div>
    </div>);
}

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}
function mapDispatchToProps(dispatch) {
    return {
        fetchDataDetail: (param) => fetchIpDetail(dispatch, param)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IpAppealDetail as any));


